import { Icon28CancelOutline } from '@vkontakte/icons';
import classNames from 'clsx';
import imageClose from 'img/Fullscreen/iconClose.png';
import { ReactComponent as Logo } from 'img/logo.svg';
import { ReactComponent as LogoRebranding } from 'img/logo-rebranding.svg';
import React, { type ReactElement, type ReactNode, createRef, PureComponent } from 'react';
import { isRebranding } from 'reactApp/appHelpers/featuresHelpers';
import { enabledCloudFullscreen } from 'reactApp/appHelpers/featuresHelpers/features/fullscreen';
import { noop } from 'reactApp/utils/helpers';
import { scrollLock, scrollUnlock } from 'reactApp/utils/scrollLock';

import styles from './Screen.css';

export interface Props {
    closable: boolean;
    children: ReactNode;
    withLogo: boolean;
    marginForHeader?: boolean;
    backSecondary?: boolean;
    className?: string;
    contentClassName?: string;

    onClose();
    aboveAll?: boolean;
}

export class Screen extends PureComponent<Props> {
    private rootRef = createRef<HTMLDivElement>();

    public static defaultProps = {
        closable: true,
        withLogo: true,
        onClose: noop,
        aboveAll: true,
        withHeader: false,
        backSecondary: false,
        className: '',
    };

    public componentDidMount(): void {
        scrollLock(this.rootRef.current, { allowTouchMove: true });
    }

    public componentWillUnmount(): void {
        scrollUnlock(this.rootRef.current);
    }

    private handleClose = (): void => {
        this.props.onClose();
    };

    public render(): ReactElement {
        const { closable, children, withLogo, marginForHeader, backSecondary, aboveAll, className, contentClassName } = this.props;

        return (
            <div
                className={classNames(styles.root, className, {
                    [styles.rootAboveAll]: aboveAll,
                    [styles.root_marginForHeader]: marginForHeader,
                    [styles.root_backSecondary]: backSecondary,
                    [styles.rebranding]: isRebranding && !backSecondary,
                })}
                ref={this.rootRef}
            >
                {closable && !enabledCloudFullscreen && (
                    <div className={styles.closeIcon} onClick={this.handleClose}>
                        <Icon28CancelOutline />
                    </div>
                )}
                {closable && enabledCloudFullscreen && (
                    <div onClick={this.handleClose} className={styles.closeIconFullscreen}>
                        <img src={`${imageClose}`} className={styles.closeIconImage} />
                    </div>
                )}
                {withLogo && <div className={styles.logo}>{isRebranding ? <LogoRebranding /> : <Logo />}</div>}
                <div className={classNames(styles.content, contentClassName)}>{children}</div>
            </div>
        );
    }
}
